import upfTheme from './upf-theme';

export default upfTheme;



// WEBPACK FOOTER //
// ./themes/index.js